import baseBackendApi from "../main/configuration/baseBackendApi";

export const getAllTips = async () => {
  const response = await baseBackendApi.get("tips/admin");
  return response.data;
};
